import { HStack } from "@/components/Elements/Layouts/Stack";
import { UserText } from "@/components/Elements/Texts/UserText";
import { valuatedState } from "@/store/propertyState";
import { yenToManOkuString, yenToManString } from "@/utils/math";
import { useRecoilState } from "recoil";
import styled from "styled-components";

const PriceText = styled.div`
  font-size: 30px;
`;

export const ResultTop = () => {
  const [valuated] = useRecoilState(valuatedState);
  return (
    <>
      <UserText>AI査定価格</UserText>

      {valuated.sale ? (
        <HStack justifyContent="center" alignItems="flex-end" spacing={1}>
          <UserText>売買価格</UserText>
          <PriceText>
            {yenToManOkuString(valuated.sale.lower)} ~{" "}
            {yenToManOkuString(valuated.sale.upper)}
          </PriceText>
          <UserText>万円</UserText>
        </HStack>
      ) : (
        <></>
      )}

      {valuated.rent ? (
        <HStack justifyContent="center" alignItems="flex-end" spacing={1}>
          <UserText>賃料</UserText>
          <PriceText>
            {yenToManString(valuated.rent.lower, 1)} ~{" "}
            {yenToManString(valuated.rent.upper, 1)}
          </PriceText>
          <UserText>万円</UserText>
        </HStack>
      ) : (
        <></>
      )}

      <h6>
        上記の価格はAIによる推定価格であり、この価格でのお取引を約束するものではありません
      </h6>
    </>
  );
};
